// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { createStore } from './store'
import { createRouter } from './router'
import ssrMixin from './mixins/ssr.mixin.js'
import './style/reset.less';
import lang from './utils/langConfig.js'
import common from './utils/common.js'
import localeLang from './utils/localeLang.js'
import VueI18n from 'vue-i18n';
import locale from 'element-ui/lib/locale';
// 引入 ElementUI 的多语言包
import enLocale from 'element-ui/lib/locale/lang/en';
import koLocale from 'element-ui/lib/locale/lang/ko';
import thLocale from 'element-ui/lib/locale/lang/th';
import viLocale from 'element-ui/lib/locale/lang/vi';

Vue.use(lang);
Vue.use(common);
Vue.mixin(ssrMixin)

Vue.config.productionTip = false


const ElementUI = require('element-ui')
require('element-ui/lib/theme-chalk/index.css')
Vue.use(VueI18n);
Vue.use(ElementUI)

const Vant = require('vant')
require('vant/lib/index.css')
Vue.use(Vant);

const messages = {
  en: {
    // 在此处放置英文语言包的键值对
    // 例如：'welcome': 'Welcome'
    ...enLocale,
  },
  kr: {
    ...koLocale,
  },
  th: {
    ...thLocale,
  },
  vn: {
    ...viLocale,
  },
};

const i18n = new VueI18n({
  locale: localeLang(), // 设置默认语言
  messages,
});

// 将 ElementUI 的多语言包与 VueI18n 配置连接起来
locale.i18n((key, value) => i18n.t(key, value));

const store = createStore()
const router = createRouter()
// router.beforeEach((to, from, next) => {
//   window.document.title = to.meta.title;
//   next()
// })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js